export const activatePrimis = () => {
  if (typeof window === "undefined") return;
  window.zeus = window.zeus || { cmd: [] };
  window.zeus.cmd.push(zeus => {
    zeus.emit("PRIMIS_ACTIVATE");
  });
};
export const deactivatePrimis = () => {
  if (typeof window === "undefined") return;
  window.zeus = window.zeus || { cmd: [] };
  window.zeus.cmd.push(zeus => {
    zeus.emit("PRIMIS_DEACTIVATE");
  });
};
